import { TableRow, TableCell, Typography, Button } from '@mui/material'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import type { TransformedCompletedActivityData } from '@/lib/apollo/query/getCompletedActivitiesForUser'
import { formatDate } from '@/utils/date'

import { rowHeight } from './utils'

export interface Props {
  activity: TransformedCompletedActivityData
}

const Row: FC<Props> = ({ activity }) => (
  <TableRow hover key={activity.activityId} sx={{ height: rowHeight }}>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {activity.details}
      </Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2" noWrap>
        {formatDate(activity.createdAt, 'dd/MM/yyyy HH:mm')}
      </Typography>
    </TableCell>
    <TableCell align="right" padding="none">
      <Button
        size="small"
        variant="text"
        component={Link}
        to={`/applicant/${activity.subjectId}`}
        sx={{ whitespace: 'noWrap' }}
      >
        View applicant
      </Button>
    </TableCell>
  </TableRow>
)

export default Row
